module.exports = __webpack_public_path__ + "img/pdf_file.33ff6e36.svg";